import React from "react";
import { WrapperComponent, CodeOqt } from "../..";

export const FormLoadTxt = ({fmk}) => {
  return (
    <>
      <WrapperComponent caption="Código" Field={<CodeOqt caption="Código" name="code" formik={fmk} variant="standard" />}/>
    </>
  )
}